import { removeHTMLFromText } from '@app/utils';
import { vendorLocation, vendorLocationLabel } from '../lib/vendor-location';
import { directoryCategorySlug } from './directory-category';
import { canonicalCategorySlug } from '../lib/seo/category-hubs.js';
import { agoraRating, googleRating } from '@lib/vendor-rating';
import { cleanAddress } from './address';
import { getSeoPrice } from './seo-locale';

export const transformVendorCardData = (vendors) =>
  vendors?.map((v) => {
    // this description have rich text format
    const cleanedDescription = removeHTMLFromText(v.description);
    const truncatedDescription = cleanedDescription.substring(0, 100).concat('...');

    // location will be hardcoded to take the neighborhood from the first service
    const neighborhood = v.services[0].neighborhood;
    const location = v.services[0].address;
    const services = v.services.map((service) => {
      // Moneda del servicio (UYU, CLP, USD…): la tarjeta la muestra con formatPrice.
      const { currency, price } = getSeoPrice(service, v.country);
      return { id: service.id, price, currency, name: service.name, duration: service.duration };
    });

    return {
      id: v.id,
      username: v.username,
      // El logo que el negocio puso en su vidriera; si no, el avatar de su usuario.
      logo: v.vendor_storefront?.storefront_avatar_url || v.user.avatar_url,
      jobTitle: v.vendor_storefront?.name,
      name: v.vendor_storefront?.name,
      neighborhood,
      location,
      description: truncatedDescription,
      services,
      created_at: v.created_at,
      tag: 'belleza',
      link: `/negocios/${v.username}`,
      source: 'agora',
      // Reseñas verificadas (la API ya manda null / 0 si el negocio no las muestra) y Google, cada una
      // con su fuente: la tarjeta elige una (lib/vendor-rating.js).
      agora: agoraRating(v.agora_rating, v.agora_review_count),
      google: googleRating(v.vendor_google_place),
      // Fotos del trabajo (galería primero) y «desde $X», ya resueltos por Cyclone. Una API vieja no
      // los manda: la tarjeta sin fotos tiene su propio diseño.
      // «Villa del Parque, CABA» / «San Martín, Buenos Aires»: casi ningún negocio carga el barrio.
      area: vendorLocationLabel(vendorLocation(v)),
      photos: Array.isArray(v.photos) ? v.photos : [],
      minPrice: v.min_price ?? (services.length ? Math.min(...services.map((s) => Number(s.price) || Infinity)) : null),
      currency: services[0]?.currency
    };
  });

export const slugifyProvince = (name) => {
  if (!name) return '';
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
};

export const transformDirectoryCardData = (listings) =>
  listings?.map((l) => ({
    id: l.place_id,
    title: l.title,
    address: cleanAddress(l.address),
    phone: l.phone,
    website: l.website,
    // `rubro_category` es la misma subcategoría que muestra la ficha; `keyword` (la búsqueda de Maps que
    // trajo el lugar) queda para las respuestas de cyclone que todavía no la traen.
    category: l.rubro_category?.name || l.keyword || l.type,
    categorySlug: l.rubro_category?.slug
      ? canonicalCategorySlug(l.rubro_category.slug)
      : directoryCategorySlug(l.keyword),
    rating: l.rating ? parseFloat(l.rating) : null,
    reviewCount: l.reviews,
    latitude: l.latitude ? parseFloat(l.latitude) : null,
    longitude: l.longitude ? parseFloat(l.longitude) : null,
    province: l.province,
    department: l.department,
    country: l.country,
    link: `/directorio/${l.place_id}`,
    source: 'directory'
  }));
